import React from "react";
import { ToastContainer } from "react-toastify";
import { AddContentSection } from "../components/CMS/Sections/AddContentSection";

export const ContentSectionsAdd = () => {
  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
          />
          <AddContentSection />
        </div>
      </div>
    </div>
  );
};
